export default "<p>learner-jobs-modal works!</p>\r\n"